export default __webpack_public_path__ + "static/media/274.96b795b5.jpg";